export default "__VITE_ASSET__XzrPLepO__"